/**
 * http://confluence.mockuai.com/display/wdzgxcx/module_property%23title
 */
let config = [{
  name: '悬浮图标',
  type: 'module-name'
},
{
  key: 'property_data',
  name: '属性',
  type: 'custom',
  content: [{
    key: 'link_data',
    name: '图片链接',
    type: 'bottom-float'
  },
  {
    key: 'width',
    name: '图片宽',
    type: 'text'
  },
  {
    key: 'height',
    name: '图片高',
    type: 'text'
  },
  {
    key: 'radius',
    name: '图片圆角',
    type: 'text'
  },
  {
    key: 'right',
    name: '右边距',
    type: 'text'
  },
  {
    key: 'bottom',
    name: '下边距',
    type: 'text'
  },
  {
    key: 'open_download',
    name: '开启下载',
    type: 'radio-box',
    'radio-list': [{
      value: 1,
      label: '关闭',
    },
    {
      value: 2,
      label: '开启',
    },
    ]
  }
  ]
}
];
export default config;
